import React, { useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, SwipeableDrawer } from '@mui/material';

import ProvinceGraphs from './ProvinceGraphs';
import ProvinceView from './ProvinceView';
import { Province } from '../../../@types/KingdomResponse';

const iOS =
  typeof navigator !== 'undefined' &&
  /iPad|iPhone|iPod/.test(navigator.userAgent);

interface Props {
  row: Province;
  hideDetailPanel: () => void;
}

const DetailPanelContent: React.FC<Props> = ({
  row: province,
  hideDetailPanel,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
    if (drawerOpen) hideDetailPanel();
  };

  return (
    <SwipeableDrawer
      anchor='right'
      open={drawerOpen}
      onClose={toggleDrawer}
      onOpen={toggleDrawer}
      disableBackdropTransition={!iOS}
      disableDiscovery={iOS}
    >
      <Box sx={{ maxWidth: '100vw', p: 1, mb: 3 }}>
        <IconButton
          sx={{ width: 30, position: 'absolute' }}
          onClick={toggleDrawer}
          size='small'
        >
          <CloseIcon />
        </IconButton>
        <ProvinceView province={province} />
        <ProvinceGraphs province={province} />
      </Box>
    </SwipeableDrawer>
  );
};

export default DetailPanelContent;
